module.exports = __webpack_public_path__ + "img/google.389a4213.png";